import { makeStyles } from '@material-ui/core';
import {INFO_BACKGROUND} from "../../../themes/themeConfigurator";
import {scrollStyles} from "../../Modelportfolios/List/styles";

export default makeStyles(theme => ({
  assetMenu: {

  },
  assetMenuItem: {
    fontFamily: 'Roboto-Regular !important',
    color: '#202A38',
  },
  assetMenuItemIcon: {
    color: '#838A93',
    fontSize: 20,
    width: 34,
    textAlign: 'center',
    '& svg': {
      verticalAlign: 'middle'
    }
  },
  assetMenuItemSelected: {
    fontFamily: 'Roboto-Bold !important',
    backgroundColor: `${INFO_BACKGROUND} !important`,
  },
  subCategories: {
    [theme.breakpoints.up('md')]: {
      height: 440,
      overflow: 'auto',
      ...scrollStyles,
    }
  }
}));